/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IbanInvoiceAddCommand } from '../models';
// @ts-ignore
import type { IbanInvoiceGetByFilterQuery } from '../models';
// @ts-ignore
import type { IbanInvoicePaginatedResponseDto } from '../models';
// @ts-ignore
import type { IbanInvoicePaymentPaginatedResponseDto } from '../models';
// @ts-ignore
import type { IbanInvoiceResponseDto } from '../models';
// @ts-ignore
import type { IbanInvoiceUpdateCommand } from '../models';
// @ts-ignore
import type { IbanInvoiceUpdateFavoriteCommand } from '../models';
// @ts-ignore
import type { IbanInvoiceValidatedResponseDto } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
/**
 * IbanInvoiceApi - axios parameter creator
 * @export
 */
export const IbanInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {IbanInvoiceUpdateFavoriteCommand} [ibanInvoiceUpdateFavoriteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceFavoritePut: async (ibanInvoiceUpdateFavoriteCommand?: IbanInvoiceUpdateFavoriteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-invoice/favorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanInvoiceUpdateFavoriteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceGet: async (pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceIbanInvoiceUidDelete: async (ibanInvoiceUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ibanInvoiceUid' is not null or undefined
            assertParamExists('apiIbanInvoiceIbanInvoiceUidDelete', 'ibanInvoiceUid', ibanInvoiceUid)
            const localVarPath = `/api/iban-invoice/{ibanInvoiceUid}`
                .replace(`{${"ibanInvoiceUid"}}`, encodeURIComponent(String(ibanInvoiceUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceIbanInvoiceUidGet: async (ibanInvoiceUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ibanInvoiceUid' is not null or undefined
            assertParamExists('apiIbanInvoiceIbanInvoiceUidGet', 'ibanInvoiceUid', ibanInvoiceUid)
            const localVarPath = `/api/iban-invoice/{ibanInvoiceUid}`
                .replace(`{${"ibanInvoiceUid"}}`, encodeURIComponent(String(ibanInvoiceUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceIbanInvoiceUidPaymentGet: async (ibanInvoiceUid: string, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ibanInvoiceUid' is not null or undefined
            assertParamExists('apiIbanInvoiceIbanInvoiceUidPaymentGet', 'ibanInvoiceUid', ibanInvoiceUid)
            const localVarPath = `/api/iban-invoice/{ibanInvoiceUid}/payment`
                .replace(`{${"ibanInvoiceUid"}}`, encodeURIComponent(String(ibanInvoiceUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IbanInvoiceAddCommand} [ibanInvoiceAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoicePost: async (ibanInvoiceAddCommand?: IbanInvoiceAddCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanInvoiceAddCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IbanInvoiceUpdateCommand} [ibanInvoiceUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoicePut: async (ibanInvoiceUpdateCommand?: IbanInvoiceUpdateCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanInvoiceUpdateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IbanInvoiceGetByFilterQuery} [ibanInvoiceGetByFilterQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceSearchPost: async (ibanInvoiceGetByFilterQuery?: IbanInvoiceGetByFilterQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-invoice/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanInvoiceGetByFilterQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IbanInvoiceApi - functional programming interface
 * @export
 */
export const IbanInvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IbanInvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {IbanInvoiceUpdateFavoriteCommand} [ibanInvoiceUpdateFavoriteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoiceFavoritePut(ibanInvoiceUpdateFavoriteCommand?: IbanInvoiceUpdateFavoriteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoiceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoiceFavoritePut(ibanInvoiceUpdateFavoriteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoiceApi.apiIbanInvoiceFavoritePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoiceGet(pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoicePaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoiceGet(pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoiceApi.apiIbanInvoiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoiceIbanInvoiceUidDelete(ibanInvoiceUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoiceIbanInvoiceUidDelete(ibanInvoiceUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoiceApi.apiIbanInvoiceIbanInvoiceUidDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoiceIbanInvoiceUidGet(ibanInvoiceUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoiceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoiceIbanInvoiceUidGet(ibanInvoiceUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoiceApi.apiIbanInvoiceIbanInvoiceUidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoiceIbanInvoiceUidPaymentGet(ibanInvoiceUid: string, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoicePaymentPaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoiceIbanInvoiceUidPaymentGet(ibanInvoiceUid, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoiceApi.apiIbanInvoiceIbanInvoiceUidPaymentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IbanInvoiceAddCommand} [ibanInvoiceAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoicePost(ibanInvoiceAddCommand?: IbanInvoiceAddCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoiceValidatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoicePost(ibanInvoiceAddCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoiceApi.apiIbanInvoicePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IbanInvoiceUpdateCommand} [ibanInvoiceUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoicePut(ibanInvoiceUpdateCommand?: IbanInvoiceUpdateCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoiceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoicePut(ibanInvoiceUpdateCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoiceApi.apiIbanInvoicePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IbanInvoiceGetByFilterQuery} [ibanInvoiceGetByFilterQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanInvoiceSearchPost(ibanInvoiceGetByFilterQuery?: IbanInvoiceGetByFilterQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanInvoicePaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanInvoiceSearchPost(ibanInvoiceGetByFilterQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanInvoiceApi.apiIbanInvoiceSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IbanInvoiceApi - factory interface
 * @export
 */
export const IbanInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IbanInvoiceApiFp(configuration)
    return {
        /**
         * 
         * @param {IbanInvoiceUpdateFavoriteCommand} [ibanInvoiceUpdateFavoriteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceFavoritePut(ibanInvoiceUpdateFavoriteCommand?: IbanInvoiceUpdateFavoriteCommand, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoiceResponseDto> {
            return localVarFp.apiIbanInvoiceFavoritePut(ibanInvoiceUpdateFavoriteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceGet(pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoicePaginatedResponseDto> {
            return localVarFp.apiIbanInvoiceGet(pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceIbanInvoiceUidDelete(ibanInvoiceUid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIbanInvoiceIbanInvoiceUidDelete(ibanInvoiceUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceIbanInvoiceUidGet(ibanInvoiceUid: string, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoiceResponseDto> {
            return localVarFp.apiIbanInvoiceIbanInvoiceUidGet(ibanInvoiceUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ibanInvoiceUid 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceIbanInvoiceUidPaymentGet(ibanInvoiceUid: string, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoicePaymentPaginatedResponseDto> {
            return localVarFp.apiIbanInvoiceIbanInvoiceUidPaymentGet(ibanInvoiceUid, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IbanInvoiceAddCommand} [ibanInvoiceAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoicePost(ibanInvoiceAddCommand?: IbanInvoiceAddCommand, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoiceValidatedResponseDto> {
            return localVarFp.apiIbanInvoicePost(ibanInvoiceAddCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IbanInvoiceUpdateCommand} [ibanInvoiceUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoicePut(ibanInvoiceUpdateCommand?: IbanInvoiceUpdateCommand, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoiceResponseDto> {
            return localVarFp.apiIbanInvoicePut(ibanInvoiceUpdateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IbanInvoiceGetByFilterQuery} [ibanInvoiceGetByFilterQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanInvoiceSearchPost(ibanInvoiceGetByFilterQuery?: IbanInvoiceGetByFilterQuery, options?: RawAxiosRequestConfig): AxiosPromise<IbanInvoicePaginatedResponseDto> {
            return localVarFp.apiIbanInvoiceSearchPost(ibanInvoiceGetByFilterQuery, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IbanInvoiceApi - object-oriented interface
 * @export
 * @class IbanInvoiceApi
 * @extends {BaseAPI}
 */
export class IbanInvoiceApi extends BaseAPI {
    /**
     * 
     * @param {IbanInvoiceUpdateFavoriteCommand} [ibanInvoiceUpdateFavoriteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoiceApi
     */
    public apiIbanInvoiceFavoritePut(ibanInvoiceUpdateFavoriteCommand?: IbanInvoiceUpdateFavoriteCommand, options?: RawAxiosRequestConfig) {
        return IbanInvoiceApiFp(this.configuration).apiIbanInvoiceFavoritePut(ibanInvoiceUpdateFavoriteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoiceApi
     */
    public apiIbanInvoiceGet(pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return IbanInvoiceApiFp(this.configuration).apiIbanInvoiceGet(pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ibanInvoiceUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoiceApi
     */
    public apiIbanInvoiceIbanInvoiceUidDelete(ibanInvoiceUid: string, options?: RawAxiosRequestConfig) {
        return IbanInvoiceApiFp(this.configuration).apiIbanInvoiceIbanInvoiceUidDelete(ibanInvoiceUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ibanInvoiceUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoiceApi
     */
    public apiIbanInvoiceIbanInvoiceUidGet(ibanInvoiceUid: string, options?: RawAxiosRequestConfig) {
        return IbanInvoiceApiFp(this.configuration).apiIbanInvoiceIbanInvoiceUidGet(ibanInvoiceUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ibanInvoiceUid 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoiceApi
     */
    public apiIbanInvoiceIbanInvoiceUidPaymentGet(ibanInvoiceUid: string, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return IbanInvoiceApiFp(this.configuration).apiIbanInvoiceIbanInvoiceUidPaymentGet(ibanInvoiceUid, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IbanInvoiceAddCommand} [ibanInvoiceAddCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoiceApi
     */
    public apiIbanInvoicePost(ibanInvoiceAddCommand?: IbanInvoiceAddCommand, options?: RawAxiosRequestConfig) {
        return IbanInvoiceApiFp(this.configuration).apiIbanInvoicePost(ibanInvoiceAddCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IbanInvoiceUpdateCommand} [ibanInvoiceUpdateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoiceApi
     */
    public apiIbanInvoicePut(ibanInvoiceUpdateCommand?: IbanInvoiceUpdateCommand, options?: RawAxiosRequestConfig) {
        return IbanInvoiceApiFp(this.configuration).apiIbanInvoicePut(ibanInvoiceUpdateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IbanInvoiceGetByFilterQuery} [ibanInvoiceGetByFilterQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanInvoiceApi
     */
    public apiIbanInvoiceSearchPost(ibanInvoiceGetByFilterQuery?: IbanInvoiceGetByFilterQuery, options?: RawAxiosRequestConfig) {
        return IbanInvoiceApiFp(this.configuration).apiIbanInvoiceSearchPost(ibanInvoiceGetByFilterQuery, options).then((request) => request(this.axios, this.basePath));
    }
}

